import { includes, values } from 'lodash';

import { CMS_LINKS } from 'app-constants';

const cmsLinks = values(CMS_LINKS);

export default function checkIsCmsLink(str: string) {
    return includes(cmsLinks, str);
}
